import { Picture } from '@/components/Picture'
import { MediaBlock } from '@/services/Api/generated'
import { Thumbnail } from '@/store/Thumbnail'
import {
  ContentItem,
  isBlockquoteBlock,
  isFrameTextBlock,
  isMediaBlock,
  isTableBlock,
} from '@/utils/editor'
import cn from 'classnames'
import { FC, FunctionComponent, PropsWithChildren, useMemo } from 'react'
import styles from './Content.module.scss'

type ContentProps = {
  className?: string
  content: ContentItem[]
}
export const Content: FunctionComponent<PropsWithChildren<ContentProps>> = ({
  className,
  content,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      {content.map((item, index) => {
        if (isMediaBlock(item)) {
          return <MediaBlockComponent key={index} data={item.data} />
        }

        if (isBlockquoteBlock(item)) {
          return (
            <blockquote key={index} className={styles.blockquote}>
              {item.data.content.text != null ? (
                <div
                  dangerouslySetInnerHTML={{ __html: item.data.content.text }}
                ></div>
              ) : null}
              <span className={styles.blockquoteAuthor}>
                {item.data.content.subText}
              </span>
            </blockquote>
          )
        }

        if (isTableBlock(item)) {
          return (
            <div
              key={index}
              className={styles.table}
              dangerouslySetInnerHTML={{ __html: item.data.content }}
            ></div>
          )
        }

        if (isFrameTextBlock(item)) {
          return (
            <div
              key={index}
              className={styles.frameText}
              dangerouslySetInnerHTML={{ __html: item.data.content }}
            ></div>
          )
        }

        return (
          <div
            key={index}
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: item.data.content }}
          ></div>
        )
      })}
    </div>
  )
}

interface MediaBlockProps {
  data: MediaBlock['data']
}
const MediaBlockComponent: FC<MediaBlockProps> = ({ data }) => {
  const thumbnail = useMemo(
    () => (data.conversions != null ? new Thumbnail(data.conversions) : null),
    [data]
  )

  return (
    <div className={styles.imageWrap}>
      {thumbnail != null ? <Picture thumbnail={thumbnail} alt="" /> : null}
      {data.imageSource != null && data.imageSource.length !== 0 ? (
        <div className={styles.descriptionLink}>{data.imageSource}</div>
      ) : null}
    </div>
  )
}
